import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.css';
import './StationHealthView.css';
import ServiceApp from './components/ServiceApp';
import App from "./components/App";
import reportWebVitals from './reportWebVitals';
import json from './dashData.json';
import json1 from './stationData1.json';
import json2 from './stationData2.json';
import json3 from './stationData3.json';
import json4 from './stationData4.json';
import json5 from './stationData5.json';
import json6 from './stationData6.json';
import json7 from './stationData7.json';
import json8 from './stationData8.json';
import json9 from './stationData9.json';
import json10 from './stationData10.json';

import "./overwrite.css"

import MeterHealthReport from './pages/MeterHealthReport';



// importing of data for MeterHealthReport
import meterJson1 from "./meter-health-report/data/meterData1.json"






const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <ServiceApp data={json}/>
    {/* <App data={json10} /> */}

    {/* <MeterHealthReport data={json10}/> */}

  </>



);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
